module.exports = __webpack_public_path__ + "img/vermouth-bianco.f93f3845.png";